var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import axios from "axios";
import { BAlert, BButton, BCard, BCardBody, BCardFooter, BCardHeader, BEmbed, BForm, BFormGroup, BFormInput, BFormText, } from "bootstrap-vue";
import { computed, ref } from "vue";
import { useRouter } from "vue-router/composables";
import localize from "@/utils/localization";
import { withPrefix } from "@/utils/redirect";
import { errorMessageAsString } from "@/utils/simple-error";
import NewUserConfirmation from "@/components/Login/NewUserConfirmation.vue";
import ExternalLogin from "@/components/User/ExternalIdentities/ExternalLogin.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'LoginForm',
    props: {
        sessionCsrfToken: null,
        redirect: { default: undefined },
        termsUrl: { default: undefined },
        welcomeUrl: { default: undefined },
        enableOidc: { type: Boolean },
        showResetLink: { type: Boolean, default: true },
        allowUserCreation: { type: Boolean },
        showWelcomeWithLogin: { type: Boolean },
        registrationWarningMessage: { default: undefined }
    },
    emits: ["toggle-login", "set-redirect"],
    setup(__props, { emit }) {
        const props = __props;
        const router = useRouter();
        const urlParams = new URLSearchParams(window.location.search);
        const login = ref("");
        const password = ref(null);
        const passwordState = ref(null);
        const loading = ref(false);
        const messageText = ref("");
        const messageVariant = ref("info");
        const connectExternalEmail = ref(urlParams.get("connect_external_email"));
        const connectExternalLabel = ref(urlParams.get("connect_external_label"));
        const connectExternalProvider = ref(urlParams.get("connect_external_provider"));
        const confirmURL = ref(urlParams.has("confirm") && urlParams.get("confirm") == "true");
        const excludeIdps = computed(() => (connectExternalProvider.value ? [connectExternalProvider.value] : undefined));
        function toggleLogin() {
            emit("toggle-login");
        }
        function submitLogin() {
            return __awaiter(this, void 0, void 0, function* () {
                let redirect;
                passwordState.value = null;
                loading.value = true;
                if (connectExternalEmail.value) {
                    login.value = connectExternalEmail.value;
                }
                if (localStorage.getItem("redirect_url")) {
                    redirect = localStorage.getItem("redirect_url");
                }
                else {
                    redirect = props.redirect;
                }
                try {
                    const response = yield axios.post(withPrefix("/user/login"), {
                        login: login.value,
                        password: password.value,
                        redirect: redirect,
                        session_csrf_token: props.sessionCsrfToken,
                    });
                    if (response.data.message && response.data.status) {
                        alert(response.data.message);
                    }
                    if (response.data.expired_user) {
                        window.location.href = withPrefix(`/root/login?expired_user=${response.data.expired_user}`);
                    }
                    else if (connectExternalProvider.value) {
                        window.location.href = withPrefix("/user/external_ids?connect_external=true");
                    }
                    else if (response.data.redirect) {
                        window.location.href = withPrefix(encodeURI(response.data.redirect));
                    }
                    else {
                        window.location.href = withPrefix("/");
                    }
                }
                catch (e) {
                    loading.value = false;
                    messageVariant.value = "danger";
                    const message = errorMessageAsString(e, "Login failed for an unknown reason.");
                    if (connectExternalProvider.value && message && message.toLowerCase().includes("invalid")) {
                        messageText.value = message + " Try logging in to the existing account through an external provider below.";
                    }
                    else {
                        messageText.value = message;
                    }
                    if (message === "Invalid password.") {
                        passwordState.value = false;
                    }
                }
            });
        }
        function setRedirect(url) {
            localStorage.setItem("redirect_url", url);
        }
        function resetLogin() {
            return __awaiter(this, void 0, void 0, function* () {
                loading.value = true;
                try {
                    const response = yield axios.post(withPrefix("/user/reset_password"), { email: login.value });
                    messageVariant.value = "info";
                    messageText.value = response.data.message;
                }
                catch (e) {
                    messageVariant.value = "danger";
                    messageText.value = errorMessageAsString(e, "Password reset failed for an unknown reason.");
                }
                finally {
                    loading.value = false;
                }
            });
        }
        function returnToLogin() {
            router.push("/login/start");
        }
        return { __sfc: true, props, emit, router, urlParams, login, password, passwordState, loading, messageText, messageVariant, connectExternalEmail, connectExternalLabel, connectExternalProvider, confirmURL, excludeIdps, toggleLogin, submitLogin, setRedirect, resetLogin, returnToLogin, BAlert, BButton, BCard, BCardBody, BCardFooter, BCardHeader, BEmbed, BForm, BFormGroup, BFormInput, BFormText, localize, withPrefix, NewUserConfirmation, ExternalLogin };
    }
});
